import { IconButton } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate, useLocation } from 'react-router-dom'
import { APPBAR_HEIGHT_REM } from '~/common/constants/layout-constants'
import { useSidebarContext } from '~/common/context/sidebar/sidebar-context'

export const PageBackButton = ({ fallback = '/' }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { sidebarWidth } = useSidebarContext()
  const handleBack = () => {
    if (location.key !== 'default') navigate(-1)
    else navigate(fallback, { replace: true })
  }
  return (
    <IconButton
      onClick={handleBack}
      sx={{
        position: 'fixed',
        top: `calc(${APPBAR_HEIGHT_REM} + 8px)`,
        left: `calc(${sidebarWidth}px + 8px)`,
        zIndex: (theme) => theme.zIndex.appBar - 1,
      }}
      aria-label="Go back"
    >
      <ArrowBack />
    </IconButton>
  )
}
